import {Component, EventEmitter, Output} from '@angular/core';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatIconModule} from '@angular/material/icon';
import {MatButtonModule} from '@angular/material/button';
import {MatMenu, MatMenuItem, MatMenuTrigger} from '@angular/material/menu';
import {MatBadge} from '@angular/material/badge';
import {inject} from '@angular/core';
import {AuthService} from '@app/services/auth.service';
import {environment} from '@env/environment';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [MatToolbarModule, MatIconModule, MatButtonModule, MatMenu, MatMenuItem, MatMenuTrigger, MatBadge],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
})
export class HeaderComponent {
  @Output() toggleMenu = new EventEmitter<void>();

  private readonly auth = inject(AuthService);
  protected readonly isProd = environment.STAGE === 'prod';
  protected readonly stage = environment.STAGE;

  logout(): void {
    this.auth.logout();
  }
}
